<template>
  <v-container fluid class="holiday-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Holiday</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Create New Holiday</p>
                        <v-menu
                          ref="menu_holidaydate"
                          v-model="menu_holidaydate"
                          :close-on-content-click="false"
                          :return-value.sync="holiday.holidaydate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              persistent-hint
                              v-model="holiday.holidaydate"
                              label="Holiday Date"
                              v-bind="attrs"
                              v-bind:value="holiday.holidaydate"
                              v-bind:error="errorindex == 0"
                              v-on="on"
                              single-line hint="Please choose the holiday date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="holiday.holidaydate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_holidaydate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_holidaydate.save(holiday.holidaydate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="mb-4"
                          v-model="holiday.holidaycode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Holiday Code"
                          persistent-hint
                          single-line hint="Enter the holiday Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="holiday.holidayname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Holiday Name"
                          persistent-hint
                          single-line hint="Enter the holiday name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="holiday.holidayinfo"
                          outlined
                          dense
                          placeholder="Holiday Info"
                          persistent-hint
                          single-line hint="Enter the holiday info">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=holidaytype
                          v-model="holiday.holidaytype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the holiday type">
                        </v-select>
                          <v-switch
                            v-model="holiday.holidaystatus"
                            color="primary"
                            v-bind:label="holiday.holidaystatus"
                            value="Active"
                          ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/holiday/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertHoliday()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      holiday: {holidaystatus: 'Active'},
      holidaytype: ['Holiday'],
      menu_holidaydate: null,
      holidaydate: null,
      error: null,
      haserror: false,
      errorindex: null,
    }
  },

  methods: {
    ...mapActions('Holiday', ['getHolidaysRequest', 'insertHolidayRequest']),
    checkError(){
      console.log(this.holiday)
      if(!this.holiday.holidaydate){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.holiday.holidaycode){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.holiday.holidayname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.holiday.holidaytype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertHoliday() {
      if(!this.checkError()) return;
      await this.insertHolidayRequest(this.holiday);
      router.push('/holiday/list');
    },
  },
  computed: {
    ...mapState('Holiday', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
